import { Suspense } from 'react';
import Loading from '../components/fragments/Loading';

export const load = (Component: any) => (props: any) => (
  <Suspense fallback={<Loading />}>
    <Component {...props} />
  </Suspense>
);
